import { NoteCountCellRenderer } from './CellRenderer';

const noteCountDef = {
  headerName: '',
  field: 'note_count',
  cellClass: 'no-border no-pad',
  suppressMenu: true,
  cellRendererFramework: NoteCountCellRenderer,
  width: 40,
  suppressSizeToFit: true,
};

const cgLastName = {
  headerName: 'CG Last Name',
  field: 'caregiverlastname',
  cellClass: 'no-border',
  suppressMenu: true,
  width: 140,
  // suppressSizeToFit: true,
};

const cgFirstName = {
  headerName: 'CG First Name',
  field: 'caregiverfirstname',
  cellClass: 'no-border',
  suppressMenu: true,
  width: 140,
  // suppressSizeToFit: true,
};

const relationDef = {
  headerName: 'Relation',
  field: 'caregiverrelationship',
  cellClass: 'no-border',
  suppressMenu: true,
  width: 160,
  // suppressSizeToFit: true,
};

export const smallWidgetPatientColumnDefs = [
  noteCountDef,
  cgLastName,
  cgFirstName,
  relationDef,
];
